import {
    useCallback,
} from 'react'
import clsx from 'clsx'
import {
    NavLink,
    useLocation,
} from 'react-router-dom'
import {
    Typography,
} from '@mui/material'
import {
    Link,
} from 'app/MainMenu/MainMenu.types'

import useStyles from './ActiveTab.style'

export default function ActiveTab({
    links,
    module,
}: Readonly<{
    links: Link[],
    module?: string,
}>) {
    const {
        pathname,
    } = useLocation()

    const {
        classes,
    } = useStyles()

    const checkIfActive = useCallback((id: string) => {
        const path = pathname.split('/')

        if (path.at(2) === module) {
            return path.at(3) === id
        }

        return path.at(2) === id
    }, [
        pathname,
        module,
    ])

    return (
        <div className={classes.root}>
            <div
                className={classes.linkContainer}
            >
                {links.map(({
                    url,
                    title,
                    id,
                }) => {
                    return (
                        <NavLink
                            key={`active-tab-links-${title}`}
                            to={url}
                            data-testid={`active-tab-links-${id}`}
                            className={clsx(
                                {
                                    [classes.link]: true,
                                    [classes.activeLink]: checkIfActive(id),
                                },
                            )}
                        >
                            <Typography
                                variant="button"
                            >
                                {title}
                            </Typography>
                        </NavLink>
                    )
                })}
            </div>
        </div>
    )
}
